import { Pressable, View } from "react-native";
import { fp, hp, spV, wp } from "utils/normalizeV2";

import { FlashList } from "@shopify/flash-list";
import ImageView from "../../src/image";
import { Images } from "assets";
import VText from "components/VText";

const ImageSelectInput = ({
    item,
    prefAnswers = [],
    setPrefAnswers = () => {},
    answerkey = "image",
    isColor = false,
}) => {
    const selectedColorAnsIds = prefAnswers?.["2"]?.map((o) => o?.optionId) || [];
    return (
        <View
            style={{
                marginBottom: spV(16),
            }}
        >
            <FlashList
                data={item?.options || []}
                numColumns={6}
                estimatedItemSize={100}
                scrollEnabled={false}
                extraData={prefAnswers}
                showsVerticalScrollIndicator={false}
                keyExtractor={(item, index) => index.toString()}
                nestedScrollEnabled
                renderItem={({ item }) => {
                    const isSelected = prefAnswers?.[answerkey]?.find((o) => o?.optionId == item?.optionId) || false;
                    return (
                        <Pressable
                            style={{
                                marginBottom: hp(12),
                                borderWidth: isSelected ? 1 : 0,
                                borderColor: "rgba(33, 36, 39, 1)",
                                opacity:
                                    isColor &&
                                    [3, "3"].includes(answerkey) &&
                                    selectedColorAnsIds?.includes(item?.optionId)
                                        ? 0.3
                                        : 1,
                            }}
                            onPress={() => {
                                if (
                                    isColor &&
                                    [3, "3"].includes(answerkey) &&
                                    selectedColorAnsIds?.includes(item?.optionId)
                                ) {
                                    return;
                                }
                                if ([2, "2"].includes(answerkey)) {
                                    setPrefAnswers((prev) => ({
                                        ...prev,
                                        [answerkey]: isSelected
                                            ? prefAnswers?.[answerkey]?.filter((o) => o?.optionId != item?.optionId)
                                            : [...(prefAnswers?.[answerkey] || []), item],
                                        [3]: isSelected
                                            ? prefAnswers?.[3]
                                            : prefAnswers?.[3]?.filter((o) => o?.optionId != item?.optionId),
                                    }));

                                    return;
                                }
                                setPrefAnswers((prev) => ({
                                    ...prev,
                                    [answerkey]: isSelected
                                        ? prefAnswers?.[answerkey]?.filter((o) => o?.optionId != item?.optionId)
                                        : [...(prefAnswers?.[answerkey] || []), item],
                                }));
                            }}
                        >
                            {!isColor && (
                                <ImageView
                                    source={{
                                        uri: item?.optionImage,
                                    }}
                                    style={{
                                        width: wp(72),
                                        height: hp(97),
                                        borderWidth: 1,
                                        borderColor: "rgba(0, 0, 0, 0.16)",
                                    }}
                                />
                            )}
                            {isColor && (
                                <>
                                    {item?.colorCode != "multi" && (
                                        <View
                                            style={{
                                                width: wp(72),
                                                height: hp(40),
                                                borderWidth: 1,
                                                borderColor: "rgba(0, 0, 0, 0.16)",
                                                backgroundColor: item?.colorCode,
                                            }}
                                        />
                                    )}
                                    {item?.colorCode == "multi" && (
                                        <ImageView
                                            style={{
                                                width: wp(72),
                                                height: hp(40),
                                                borderWidth: 1,
                                                borderColor: "rgba(0, 0, 0, 0.16)",
                                            }}
                                            source={Images.multiColor}
                                        />
                                    )}
                                </>
                            )}

                            <VText
                                text={item?.optionName?.slice(0, 30) || ""}
                                style={{
                                    paddingTop: hp(8),
                                    fontSize: fp(12),
                                    textAlign: "center",
                                    textTransform: "capitalize",
                                }}
                                numberOfLines={1}
                            />
                        </Pressable>
                    );
                }}
                ListHeaderComponent={() => (
                    <VText
                        text={item?.question}
                        style={{
                            fontSize: fp(16),
                            paddingBottom: hp(16),
                            fontWeight: "500",
                        }}
                    />
                )}
            />
        </View>
    );
};

export default ImageSelectInput;
